export default __webpack_public_path__ + "static/media/inn.93a6288c.png";